import React, {useState} from 'react';
import PayFormContainer from '../../followup/containers/PayFormContainer';
import { BackButton } from '../../shared/components/Buttons';
import {withTranslation} from "react-i18next";
import Modal from "../../shared/components/Modal";

const PayBalance = ({ onCancel, t }) => {
    const [open, setOpen] = useState(true);

    const handleCancel = (open) => {
        setOpen(open)
        onCancel()
    }

    return <Modal open={open} hideClose={true} setOpen={handleCancel} title={t('followup.choice_of_payment_method')}>
        <div>
            <PayFormContainer/>

            <BackButton
                type="button"
                className="btn-primary btn-lg btn-warning mt-5"
                onClick={handleCancel}
            >
                {t('followup.back')}
            </BackButton>
        </div>
    </Modal>
};

export default withTranslation()(PayBalance);
